export default function updateChecklist (state, checklist) {
  state.checklists = state.checklists.map(item => {
    if (item.id === checklist.id) {
      return checklist
    }

    return item
  })
}
